import "./payslip.less";

angular.module("tromanWeb").component('ergoPayslipList', {
    template: require('./payslipList.html'),
    bindings: {
        collection: '<',
        wageTypes: '<',
        paymentLock: '<',
        onFilter: '&',
        onSelection: '&',
    },
});
